export default __webpack_public_path__ + "static/media/Technicaldesign.22bc408a.svg";